import React from "react";
import Section from "./Section";

export default function Contact() {
    return (
        <Section id="contact" subtitle="Get in touch" title="Contact">
            <div className="max-w-xl">
                <p className="text-stone-600 dark:text-stone-400 leading-relaxed">
                    I am open to scoped builds, hourly work, and ongoing product support.
                </p>
                <div className="mt-4 text-sm text-stone-500 dark:text-stone-500 space-y-2">
                    <div>Location: Addis Ababa, Ethiopia</div>
                    <div>Hourly: <span className="font-medium text-black dark:text-white">$35/hr</span></div>
                    <div>Full project: <span className="font-medium text-black dark:text-white">from $3,500</span></div>
                    <div>Email: <a className="text-black dark:text-white font-medium hover:underline" href="mailto:hello@natnaeladane.dev">hello@natnaeladane.dev</a></div>
                </div>
                <a
                    href="mailto:hello@natnaeladane.dev"
                    className="mt-8 inline-flex items-center justify-center bg-black text-white dark:bg-white dark:text-black px-6 py-3.5 font-mono font-bold uppercase tracking-wider text-xs hover:bg-stone-800 dark:hover:bg-stone-200 transition-colors"
                >
                    Email me
                </a>
            </div>
        </Section>
    );
}
